/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
export default {
    confirmDelete: { SC:"您确定要删除吗？", TC: "您確定要删除嗎？" , EN: "Are you sure to delete?" }
    ,cancel: { SC:"取消", TC: "取消", EN: "No" }
    ,confirmLeave: { SC:"当前页信息还未保存，请确定是否离开？", TC: "當前頁資訊還未保存，請確定是否離開？" , EN: "The current page information has not been saved, please confirm whether to leave?" }
    ,sysfunc: { SC:"模块已被角色/我的最爱使用，请确定是否一并删除？", TC: "模塊已被角色/我的最愛使用，請確定是否一併删除？" , EN: "The module has been used by a Role/My Favorite, please confirm whether to delete it?" }
    ,save: { SC:"确定", TC: "確定", EN: "Yes" }
    ,OffCallBack: { SC:"请传入关闭弹框的回调方法", TC: "請傳入關閉彈框的回檔方法", EN: "Please pass in the callback method to close the pop-up." }
}